var React = require('react');

function Error (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 0C13.4 0 0 13.4 0 30s13.4 30 30 30 30-13.4 30-30S46.6 0 30 0zm0 33a3.01 3.01 0 0 1-3-3V18c0-1.7 1.3-3 3-3s3 1.3 3 3v12a3.01 3.01 0 0 1-3 3zm0 12c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3z"}));
}

Error.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 60 60","overflow":"visible"};

module.exports = Error;

Error.default = Error;
